import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/footer_logo.png'
import _imports_1 from '@/assets/qrcode.jpg'


const _withScopeId = n => (_pushScopeId("data-v-19d41768"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "z-footer"
}
const _hoisted_2 = { class: "w1200" }
const _hoisted_3 = { class: "z-footer__body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "z-footer__left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo",
    width: "230",
    height: "50"
  }),
  /*#__PURE__*/_createElementVNode("div", null, "用我们的产品，造就更多人的幸福")
], -1))
const _hoisted_5 = { class: "z-footer__mid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "友情链接", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "z-footer__right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "qrcode"
  }),
  /*#__PURE__*/_createElementVNode("div", null, "关注\"中通招聘\"了解更多动态")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "z-footer__copyright" }, "中通快递股份有限公司©版权所有 沪ICP备13044869号-2", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.$isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", null, [
                _hoisted_6,
                _createElementVNode("li", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick('https://www.zto.com')))
                }, "中通官网"),
                _createElementVNode("li", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick('https://izto.com')))
                }, "中通科技")
              ])
            ]),
            _hoisted_7
          ])
        ]),
        _hoisted_8
      ]))
    : _createCommentVNode("", true)
}